import { render } from "./DealsSlider.vue?vue&type=template&id=757f901b"
import script from "./DealsSlider.vue?vue&type=script&lang=js"
export * from "./DealsSlider.vue?vue&type=script&lang=js"

import "./DealsSlider.vue?vue&type=style&index=0&id=757f901b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__